import { createPieChartConfig } from "@/lib";
import { HighchartsReact } from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import { memo } from "react";
import type { Props } from "./types";

function PieChart({ data, colors, size = 145 }: Props) {
	return (
		<HighchartsReact
			highcharts={Highcharts}
			options={createPieChartConfig({
				colors,
				data,
				innerSize: 55,
				height: size,
				width: size,
				plotOptions: {
					borderWidth: 1,
					animation: false,
					clip: true,
					enableMouseTracking: false,
				},
				size,
			})}
		/>
	);
}

export default memo(PieChart);
